import { NgClass } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-check',
  imports: [NgClass],
  templateUrl: './check.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './check.component.scss',
})
export class CheckComponent {
  @Input() public size = 6;
}
